import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  CreateTemplateData,
  GetTemplateSingleRow,
} from "../../services/CompanyService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { Container, Row, Col } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import Form from "react-bootstrap/Form";

const MailTemplateEditor = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  // State for all form data
  const [formDataValues, setFormDataValues] = useState({
    name: "",
    desc: "",
    subject: "",
    mail_content: [{ id: Date.now(), type: "text", content: "" }],
    header_text: "",
  });

  const [showPreview, setShowPreview] = useState(false);
  const [placeholders, setPlaceholders] = useState([]);
  const quillRefs = {}; // For holding references to each Quill editor instance

  // Fetch template data when id changes
useEffect(() => {
  if (id) {
    GetTemplateSingleRow(id)
      .then(res => {
        if (res?.status === 200) {
          const responseData = res.data;

          const placeholdersData = responseData?.data?.placeholders || [];

          // ✅ HTML ONLY — NO JSON.parse
          const mailContentData = responseData?.data?.content || "";

          setPlaceholders(placeholdersData);

          setFormDataValues(prevValues => ({
            ...prevValues,
            name: responseData?.data?.name || "",
            desc: responseData?.data?.description || "",
            subject: responseData?.data?.subject || "",
            header_text: responseData?.data?.header_text || "",
            mail_content: [
              {
                id: Date.now(),
                type: "text",
                content: mailContentData, // ✅ PURE HTML
              },
            ],
          }));
        }
      })
      .catch(err => {
        console.error(err, "errors");
        toast.error("No data available for the template.");
      });
  }
}, [id]);

  // Update component content
  const updateComponentContent = (id, content) => {
    setFormDataValues(prev => ({
      ...prev,
      mail_content: prev.mail_content.map(comp =>
        comp.id === id ? { ...comp, content } : comp
      ),
    }));
  };

  // Add new component
  const addComponent = type => {
    const newComponent = {
      id: Date.now(),
      type,
      content:
        type === "text" ? "" : type === "image" ? "Image URL" : "Button Text",
    };
    setFormDataValues(prev => ({
      ...prev,
      mail_content: [...prev.mail_content, newComponent],
    }));
  };

  // Remove component
  const removeComponent = id => {
    setFormDataValues(prev => ({
      ...prev,
      mail_content: prev.mail_content.filter(comp => comp.id !== id),
    }));
  };

  const isEmptyContent = content => {
    const strippedContent = content.replace(/<[^>]*>?/gm, "").trim();
    return strippedContent.length === 0;
  };

  // Save the template
  const handleSave = async e => {
    e.preventDefault();
    const { name, subject, mail_content, desc, header_text } = formDataValues;
    if (!name.trim()) {
      toast.error("Please fill Template Name.");
      return;
    }
    // Validate mail_content
    if (mail_content.length === 0 || isEmptyContent(mail_content[0]?.content)) {
      toast.error("Mail content is required!");
      return;
    }

    console.log(
      mail_content[0]?.content.trim(),
      "mail_content[0]?.content.trim()"
    );
    const payload = {
      template_name: name,
      template_desc: desc,
      mail_subject: subject,
      headerText: header_text,
      mail_content: mail_content[0]?.content || "",
      template_id: id,
    };

    try {
      const res = await CreateTemplateData(payload);
      if (res.status === 200) {
        toast.success(t("Template saved successfully!"));
        window.location.href = "/template-list";
      } else {
        toast.error("Failed to save the template.");
      }
    } catch (error) {
      console.error("Error saving template:", error);
    }
  };

  // Insert placeholder at cursor position
  const insertPlaceholder = (id, placeholder) => {
    const quill = quillRefs[id].getEditor(); // Get the Quill editor instance
    if (quill) {
      const selection = quill.getSelection();
      if (selection) {
        const cursorPosition = selection.index;
        quill.insertText(cursorPosition, placeholder); // Insert placeholder
      } else {
        const content = formDataValues.mail_content.find(
          comp => comp.id === id
        ).content;
        const newContent = content + placeholder;
        updateComponentContent(id, newContent);
      }
    }
  };

  // Render preview
  const renderPreview = () => {
    return formDataValues.mail_content.map(component => (
      <div
        key={component.id}
        style={{
          marginBottom: "10px",
          padding: "10px",
          background: "#f4f4f4",
          border: "1px solid #ddd",
          borderRadius: "5px",
        }}
      >
        {component.type === "text" && (
          <div dangerouslySetInnerHTML={{ __html: component.content }} />
        )}
        {component.type === "image" && (
          <img
            src={component.content}
            alt="Preview"
            style={{ maxWidth: "100%" }}
          />
        )}
        {component.type === "button" && (
          <button style={{ padding: "10px", border: "1px solid #ccc" }}>
            {component.content}
          </button>
        )}
      </div>
    ));
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  return (
    <div className="page-content only-form-padding">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/franchise-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Template_Edit.Edit_Template`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-3">
            <Row>
              {/* Template Name */}
              <Form.Group className="col-md-3 mb-3 floating-label">
                <Form.Label className="float-label" htmlFor="template-name">
                  {t(`Template_Edit.Template_Name`)}
                </Form.Label>
                <input
                  id="template-name"
                  type="text"
                  value={formDataValues?.name}
                  onChange={e =>
                    setFormDataValues(prev => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  placeholder={t(`Template_Edit.Template_Name`)}
                  className="form-control"
                  title={`${t(`Template_Edit.Template_Name`)}`}
                />
              </Form.Group>
              {/* Template Description */}
              <Form.Group className="col-md-3 mb-3 floating-label">
                <label htmlFor="template-description">
                  {t(`Template_Edit.Template_Description`)}
                </label>
                <input
                  id="template-description"
                  type="text"
                  value={formDataValues?.desc}
                  placeholder={t(`Template_Edit.Template_Description`)}
                  className="form-control"
                  title={`${t(`Template_Edit.Template_Description`)}`}
                />
              </Form.Group>

              {/* Header Text */}
              <Form.Group className="col-md-3 mb-3 floating-label">
                <label htmlFor="header-text">
                  {t(`Template_Edit.Header_Text`)}
                </label>
                <input
                  id="header-text"
                  type="text"
                  value={formDataValues.header_text}
                  onChange={e =>
                    setFormDataValues(prev => ({
                      ...prev,
                      header_text: e.target.value,
                    }))
                  }
                  // Remove placeholder to avoid duplicate labeling
                  className="form-control"
                  title={`${t(`Template_Edit.Header_Text`)}`}
                />
              </Form.Group>

              {/* Select Placeholder */}
              <Form.Group className="col-md-3 mb-3 floating-label">
                <label htmlFor="header-text">
                  {t(`Template_Edit.Place_Holder`)}
                </label>
                <select
                  onChange={e => {
                    e.preventDefault();
                    const selectedValue = e.target.value;
                    if (selectedValue) {
                      formDataValues.mail_content.forEach(component => {
                        if (component.type === "text") {
                          insertPlaceholder(component.id, selectedValue);
                        }
                      });
                    }
                  }}
                  className="form-control"
                  onMouseEnter={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                  }}
                >
                  <option value="">Select Placeholder</option>
                  {placeholders.map(placeholder => (
                    <option key={placeholder.id} value={placeholder.name}>
                      {placeholder.name}
                    </option>
                  ))}
                </select>
              </Form.Group>

              {/* Components */}
              <Form.Group className="col-md-12 mb-3 floating-label">
                {formDataValues.mail_content.map(component => (
                  <div
                    key={component.id}
                    data-id={component.id}
                    className="mail-template-component"
                    title={`Comment`}
                  >
                    {component.type === "text" && (
                      <ReactQuill
                        theme="snow"
                        value={component.content}
                        onChange={content =>
                          updateComponentContent(component.id, content)
                        }
                        ref={el => {
                          if (el) {
                            quillRefs[component.id] = el;
                          }
                        }}
                        style={{
                          minHeight: "200px",
                          maxHeight: "400px",
                          overflowY: "auto",
                          resize: "vertical",
                        }}
                      />
                    )}
                    {component.type === "image" && (
                      <input
                        type="text"
                        value={component.content}
                        onChange={e =>
                          updateComponentContent(component.id, e.target.value)
                        }
                        placeholder="Enter image URL"
                        style={{ width: "100%" }}
                      />
                    )}
                    {component.type === "button" && (
                      <input
                        type="text"
                        value={component.content}
                        onChange={e =>
                          updateComponentContent(component.id, e.target.value)
                        }
                        placeholder="Button Text"
                        style={{ width: "100%" }}
                      />
                    )}
                  </div>
                ))}
                {formDataValues.mail_content.length === 0 && (
                  <p>Add components to display here...</p>
                )}
              </Form.Group>

              {/* Save and Preview Buttons */}
              <div className="d-flex gap-3 primary-btn">
                <button onClick={handleSave} className="btn btn-primary">
                  Save Template
                </button>
                <button
                  onClick={() => (window.location.href = "/template-list")}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </Row>
          </div>
        </div>

        {/* Preview Panel */}
        <div
          style={{
            width: "25%",
            border: "2px solid #ccc",
            minHeight: "400px",
            padding: "20px",
            background: "#f9f9f9",
            borderRadius: "5px",
            display: showPreview ? "block" : "none",
          }}
        >
          <h3>Preview</h3>
          {renderPreview()}
        </div>
      </Container>
    </div>
  );
};

export default MailTemplateEditor;
